// extracted by mini-css-extract-plugin
export default {"productCarousel":"Oja-z"};